import React, { useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';
import API_URL from '../config/ApiUrl';
const VideoChat = ({ title, roomName, onParticipantCountChange, currentUser, onNewMessage, onMessagesLoaded, onMessageError, autoJoin = true }) => {



  const [socket, setSocket] = useState(null);
  const [roomId, setRoomId] = useState(roomName || title || 'test-room');
  const [isInRoom, setIsInRoom] = useState(false);
  const [roomUsers, setRoomUsers] = useState([]);
  const [remoteStreams, setRemoteStreams] = useState({});
  const [connectionStatus, setConnectionStatus] = useState('Disconnected');

  const [userInfo, setUserInfo] = useState({});
    const shouldCall = (myId, theirId) => myId < theirId;

  const localVideoRef = useRef(null);
  const localStreamRef = useRef(null);
  const peerConnectionsRef = useRef({});

   const [servers, setServers] = useState({
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' } // Fallback
      ]
    });
  
    // Add this useEffect to get Twilio TURN servers
    useEffect(() => {
      const getTurnServers = async () => {
        try {
          const response = await fetch(`${API_URL}/api/turn-credentials`, {
            method: 'POST',
            credentials: 'include'
          });
          const data = await response.json();
          
          console.log('🎯 Got Twilio TURN servers:', data.iceServers);
          setServers({ iceServers: data.iceServers });
        } catch (error) {
          console.error('❌ Failed to get TURN servers:', error);
        }
      };
      
      getTurnServers();
    }, []);
  // WebRTC handler functions defined FIRST
  const createPeerConnection = (remoteUserId, socketRef) => {
    
    const pc = new RTCPeerConnection(servers);
    
    // Add local stream
    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(track => {

        pc.addTrack(track, localStreamRef.current);
      });
    }

    // Handle remote stream
    pc.ontrack = (event) => {
      console.log('📊 Stream details:', {
        streamId: event.streams[0].id,
        trackCount: event.streams[0].getTracks().length,
        videoTracks: event.streams[0].getVideoTracks().length,
        audioTracks: event.streams[0].getAudioTracks().length
      });
      
      setRemoteStreams(prev => {
        const updated = {
          ...prev,
          [remoteUserId]: event.streams[0]
        };
        return updated;
      });
    };

    // Handle ICE candidates
    pc.onicecandidate = (event) => {
      console.log('==================================================================');
      console.log('=ICE CANDIDATE EVENT=', event);
      console.log('=REMOTE USER=', remoteUserId);
      console.log('=HAS CANDIDATE=', !!event.candidate);
      if (event.candidate) {
        console.log('=CANDIDATE TYPE=', event.candidate.type);
        console.log('=CANDIDATE STRING=', event.candidate.candidate);
        // CHANGE THIS LINE:
        console.log('=socketRef EXISTS=', !!socketRef);  // Use newSocket instead of socket
        console.log('=socketRef CONNECTED=', socketRef?.connected);
        console.log('=SOCKET CONNECTED=', socket?.connected);
      }
      console.log('==================================================================');
      
      if (event.candidate && socketRef?.connected) {  // Use newSocket here too
        console.log(" IN THE IF IN THE IF VIDEO CHAT COMPO ")

        socketRef.emit('webrtc-message', {
          type: 'ice-candidate',
          candidate: event.candidate,
          roomId: roomId,
          targetUser: remoteUserId
        });
      }
    };

    // Connection state monitoring
    pc.onconnectionstatechange = () => {
      console.log(`Connection with ${remoteUserId}:`, pc.connectionState);
    };

    peerConnectionsRef.current[remoteUserId] = pc;
    return pc;
  };

  const initiateCallToUser = async (targetUserId) => {
      console.log(`📞 Initiating call to ${targetUserId}`);
      console.log(`📞 Initiating call to ${targetUserId}`);
      console.log(`🔍 Current peer connections:`, Object.keys(peerConnectionsRef.current));
      console.log(`🔍 Checking for existing connection to ${targetUserId}:`, peerConnectionsRef.current[targetUserId]);
      
        console.log(`📞 Initiating call to ${targetUserId}`);
      console.log('IN THE VIDEO CHAT')
      console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
      console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
      console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
      console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
      console.log('Is Connected: ', socket?.connected)
      console.log('Is Connected: ', !socket?.connected)
    if (!socket?.connected) {
      console.log('❌ Socket not ready, waiting...');
      setTimeout(() => initiateCallToUser(targetUserId), 1000);
      return;
    }
    if (peerConnectionsRef.current[targetUserId]) {
      console.log(`⏭️ Already have peer connection for ${targetUserId}`);
    }
    
    try {
      const pc = createPeerConnection(targetUserId, socket);
      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);
      
      if (socket && socket.connected) {
        socket.emit('webrtc-message', {
          type: 'offer',
          offer: offer,
          roomId: roomId,
          targetUser: targetUserId
        });
        console.log(`📤 Sent offer to ${targetUserId}`);
      } else {
        console.error('❌ Socket not available to send offer');
      }
    } catch (error) {
      console.error('❌ Error initiating call:', error);
    }
  };

  const getUsernameFromSocketId = (socketId) => {
    if (socketId === socket?.id) {
      return currentUser?.username || 'You';
    }
    return userInfo[socketId]?.username || `User ${socketId?.slice(-4) || 'Unknown'}`;
  };
  

  useEffect(() => {
    if (onParticipantCountChange) {
      onParticipantCountChange(roomUsers.length);
    }
  }, [roomUsers.length, onParticipantCountChange]);
  

  useEffect(() => {
    
    const newSocket = io(`${API_URL}`);
    setSocket(newSocket);

    // Define WebRTC handler inside useEffect to access current socket
    const handleWebRTCMessage = async (data) => {
      console.log('VIDE CHAT')
      console.log('==================================================================');
      console.log('=WEBRTC MESSAGE RECEIVED=', data.type);
      console.log('=FROM=', data.from);
      console.log('=HAS ICE CANDIDATE=', !!data.candidate);
      if (data.candidate) {
        console.log('=RECEIVED CANDIDATE TYPE=', data.candidate.type);
      }
      console.log('==================================================================');
      const { type, from, fromUser } = data;
      const fromUsername = fromUser?.username || getUsernameFromSocketId(from); // ADD this line
      try {
        if (type === 'offer') {
          const pc = createPeerConnection(from, newSocket);
          await pc.setRemoteDescription(new RTCSessionDescription(data.offer));
          
          const answer = await pc.createAnswer();
          await pc.setLocalDescription(answer);
          
          if (newSocket && newSocket.connected) {
            newSocket.emit('webrtc-message', {
              type: 'answer',
              answer: answer,
              roomId: roomId,
              targetUser: from
            });
            console.log(`📤 Sent answer to ${from}`);
          }
          
        } else if (type === 'answer') {
          const pc = peerConnectionsRef.current[from];
          if (pc) {
            await pc.setRemoteDescription(new RTCSessionDescription(data.answer));
          }
          
        } else if (type === 'ice-candidate') {
          const pc = peerConnectionsRef.current[from];
          if (pc && data.candidate) {
            await pc.addIceCandidate(new RTCIceCandidate(data.candidate));
          }
        }
      } catch (error) {
        console.error(`❌ Error handling ${type}:`, error);
      }
    };

    

    // Get user media with fallback options
    const getMediaStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: { width: 640, height: 480 }, 
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true
          }
        });

        stream.isLocalStream = true;
        
        return stream;
      } catch (cameraError) {
        console.log('❌ Camera failed, trying screen share...', cameraError.message);
        try {
          const stream = await navigator.mediaDevices.getDisplayMedia({ 
            video: true, 
            audio: true 
          });
          console.log('🖥️ Got screen share media');
          return stream;
        } catch (screenError) {
          console.error('❌ Both camera and screen share failed:', screenError);
          throw screenError;
        }
      }
    };

    getMediaStream()
    .then(stream => {
      localStreamRef.current = stream;
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = stream;
      }
      setConnectionStatus('Ready');
    })
    .catch(error => {
      console.error('❌ Media error:', error);
      setConnectionStatus('Media Error - Click to Share Screen');
    });

    // Socket event listeners
    newSocket.on('connect', () => {
      console.log('🔌 Connected to server');
      setConnectionStatus('Connected');
      
      // ADD THIS: Authenticate user immediately after connection
      if (currentUser) {
        console.log('🔐 Authenticating user:', currentUser.username);
        newSocket.emit('authenticate-user', {
          id: currentUser.id,
          username: currentUser.username,
          email: currentUser.email,
          smoker_level: currentUser.smoker_level
        });
      }
    });

    newSocket.on('disconnect', () => {
      console.log('🔌 Disconnected');
      setConnectionStatus('Disconnected');
      setIsInRoom(false);
    });

    newSocket.on('room-info', (data) => {
      console.log('🏠 Room info:', data);
      setRoomUsers(data.users);
      setIsInRoom(true);
      
      // ADD THIS: Update user info mapping
      if (data.usersInfo) {
        console.log('👥 Updating user info:', data.usersInfo);
        setUserInfo(data.usersInfo);
      }
      
      // Auto-call existing users when we join
      setTimeout(() => {
        data.users.forEach(userId => {
          if (
            userId !== newSocket.id && 
            localStreamRef.current &&
            shouldCall(newSocket.id, userId)
          ) {
            console.log(`🚀 Auto-calling existing user: ${userId}`);
            initiateCallToUser(userId);
          }
        });
      }, 2000);
    });

    newSocket.on('user-joined', (data) => {
      
      setRoomUsers(prev => {
        const updated = [...prev.filter(id => id !== data.userId), data.userId];
        return updated;
      });
      
      // ADD THIS: Update user info if provided
      if (data.userInfo) {
        setUserInfo(prev => ({
          ...prev,
          [data.userId]: data.userInfo
        }));
      }
      
      // Automatically initiate call to new user
      setTimeout(() => {
        
        if (
          localStreamRef.current &&
          newSocket &&
          shouldCall(newSocket.id, data.userId)
        ) {
          initiateCallToUser(data.userId);
        }
      }, 3000);
    });

    newSocket.on('user-left', (data) => {
      setRoomUsers(prev => prev.filter(id => id !== data.userId));
      
      // Clean up peer connection
      if (peerConnectionsRef.current[data.userId]) {
        peerConnectionsRef.current[data.userId].close();
        delete peerConnectionsRef.current[data.userId];
      }
      
      // Remove remote stream
      setRemoteStreams(prev => {
        const newStreams = { ...prev };
        delete newStreams[data.userId];
        return newStreams;
      });
    });

    // newSocket.on('new-message', (messageData) => {
    //   // Forward to parent component
    //   console.log('📨 Message received in VideoChat:', messageData);
    // });

    // newSocket.on('messages-loaded', (data) => {
    //   console.log('📋 Messages loaded in VideoChat:', data.messages.length);
    // });

    newSocket.on('webrtc-message', handleWebRTCMessage);


    newSocket.on('authentication-confirmed', (data) => {
      console.log('✅ Authentication confirmed:', data);
    });


    return () => {
      console.log('🧹 Cleanup');
      if (localStreamRef.current) {
        localStreamRef.current.getTracks().forEach(track => track.stop());
      }
      Object.values(peerConnectionsRef.current).forEach(pc => pc.close());
      newSocket.disconnect();
    };
  }, [roomId]);

  const startScreenShare = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({ 
        video: true, 
        audio: true 
      });
      
      localStreamRef.current = stream;
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = stream;
      }
      setConnectionStatus('Ready');
      
      // Update existing peer connections with new stream
      Object.values(peerConnectionsRef.current).forEach(pc => {
        const senders = pc.getSenders();
        stream.getTracks().forEach(track => {
          const sender = senders.find(s => s.track && s.track.kind === track.kind);
          if (sender) {
            sender.replaceTrack(track);
          }
        });
      });
      
      console.log('🖥️ Screen share started');
    } catch (error) {
      console.error('❌ Screen share failed:', error);
    }
  };

  const joinRoom = () => {
    if (socket && roomId.trim()) {
      console.log(`🚪 Joining room: ${roomId}`);
      socket.emit('join-room', { roomId: roomId.trim() });
    }
  };

  useEffect(() => {
    if (autoJoin && socket && connectionStatus === 'Ready' && !isInRoom) {
      console.log('🚀 AUTO-JOINING ROOM:', roomId);
      setTimeout(() => {
        joinRoom();
      }, 1000); // Small delay to ensure everything is ready
    }
  }, [socket, connectionStatus, autoJoin, isInRoom, roomId]);

  const callAllUsers = () => {
    console.log('📞 Calling all users in room');
    roomUsers.forEach(userId => {
      if (
        userId !== socket?.id && 
        !remoteStreams[userId] &&
        shouldCall(socket.id, userId)
      ) {
        console.log(`📞 Calling user: ${userId}`);
        setTimeout(() => initiateCallToUser(userId), 500);
      }
    });
  };

  return (
 <div style={{
   minHeight: '100vh',
   background: 'rgb(26, 26, 26)',
   fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif"
 }}>
   <div style={{ padding: '24px' }}>
     
     {/* Material UI Header Card */}
     <div style={{
       background: 'rgba(255, 255, 255, 0.95)',
       backdropFilter: 'blur(10px)',
       borderRadius: '16px',
       padding: '24px',
       marginBottom: '24px',
       boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
       border: '1px solid rgba(255, 255, 255, 0.2)'
     }}>
       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
         <div>
           <h1 style={{
             fontSize: '32px',
             fontWeight: '700',
             color: '#1976d2',
             margin: '0 0 8px 0',
             letterSpacing: '-0.5px'
           }}>
             {title || 'Video Conference'}
           </h1>
           <div style={{
             display: 'flex',
             alignItems: 'center',
             gap: '8px',
             fontSize: '16px',
             color: '#666'
           }}>
             <div style={{
               width: '8px',
               height: '8px',
               borderRadius: '50%',
               backgroundColor: connectionStatus === 'Ready' ? '#4caf50' : connectionStatus === 'Connected' ? '#ff9800' : '#f44336'
             }}></div>
             <span>{connectionStatus}</span>
             {!isInRoom && connectionStatus === 'Ready' && (
               <span> • Auto-joining room...</span>
             )}
           </div>
         </div>
         <div style={{
           width: '64px',
           height: '64px',
           background: 'linear-gradient(45deg, #2196f3, #21cbf3)',
           borderRadius: '16px',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           fontSize: '28px'
         }}>
           🎥
         </div>
       </div>
     </div>

     {/* Connecting Message - NO JOIN FORM */}
     {!isInRoom ? (
       <div style={{
         background: 'rgba(255, 255, 255, 0.95)',
         backdropFilter: 'blur(10px)',
         borderRadius: '16px',
         padding: '32px',
         marginBottom: '24px',
         boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
         border: '1px solid rgba(255, 255, 255, 0.2)',
         textAlign: 'center'
       }}>
         <h2 style={{
           fontSize: '24px',
           fontWeight: '600',
           color: '#333',
           marginBottom: '16px'
         }}>
           Connecting to {title || roomId}...
         </h2>
         <div style={{
           width: '40px',
           height: '40px',
           border: '4px solid #e0e0e0',
           borderTop: '4px solid #2196f3',
           borderRadius: '50%',
           animation: 'spin 1s linear infinite',
           margin: '0 auto'
         }} />
       </div>
     ) : (
          <div style={{
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            padding: '24px',
            marginBottom: '24px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h2 style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#333',
                  margin: '0 0 8px 0'
                }}>
                  Room: <span style={{ color: '#2196f3' }}>{roomId}</span>
                </h2>
                <p style={{
                  margin: 0,
                  color: '#666',
                  fontSize: '16px'
                }}>
                  {roomUsers.length} participant{roomUsers.length !== 1 ? 's' : ''} connected
                </p>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <button
                  onClick={callAllUsers}
                  style={{
                    padding: '12px 24px',
                    fontSize: '14px',
                    fontWeight: '600',
                    background: 'linear-gradient(45deg, #4caf50, #66bb6a)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(76, 175, 80, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  📞 Start Video Calls
                </button>
                <button
                  onClick={startScreenShare}
                  style={{
                    padding: '12px 24px',
                    fontSize: '14px',
                    fontWeight: '600',
                    background: 'linear-gradient(45deg, #ff9800, #ffb74d)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(255, 152, 0, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  🖥️ Share Screen
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Video Grid */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '24px',
          justifyContent: 'center'
        }}>
          {/* Local Video - Material UI Card Style */}
          <div style={{
            width: '400px',
            height: '300px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
          }}>
            <div style={{
              background: 'linear-gradient(45deg, #2196f3, #21cbf3)',
              padding: '16px',
              color: 'white',
              fontWeight: '600',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '20px'
            }}>
              <span>You (Local)</span>
              <div style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#4caf50',
                animation: 'pulse 2s infinite'
              }}></div>
            </div>
            <div style={{ width: '400px', height: '250px', position: 'relative' }}>
              <video
                ref={localVideoRef}
                autoPlay
                muted={true}
                playsInline
                style={{
                  width: '400px',
                  height: '250px',
                  objectFit: 'cover',
                  backgroundColor: '#000'
                }}
              />
            </div>
          </div>

          {/* Remote Videos - Same Material UI Style */}
          {Object.entries(remoteStreams).map(([userId, stream]) => {
            const username = getUsernameFromSocketId(userId); // ADD this line
            return <RemoteVideo key={userId} userId={userId} username={username} stream={stream} />; // ADD username prop
          })}

          {/* Placeholder for users without video - Material UI Style */}
          {roomUsers
            .filter(userId => {
              const isNotMe = userId !== socket?.id;
              const hasNoStream = !remoteStreams[userId];
              return isNotMe && hasNoStream;
            })
            .map(userId => (
              <div key={userId} style={{
                width: '400px',
                height: '300px',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
              }}>
                <div style={{
                  background: 'linear-gradient(45deg, #ff9800, #ffb74d)',
                  padding: '16px',
                  color: 'white',
                  fontWeight: '600',
                  fontSize: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '20px'
                }}>
                  <span>User {userId.slice(-4)} - Connecting...</span>
                  <div style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#fff',
                    opacity: '0.8',
                    animation: 'pulse 1s infinite'
                  }}></div>
                </div>
                <div style={{
                  width: '400px',
                  height: '250px',
                  backgroundColor: '#f5f5f5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <div style={{ textAlign: 'center', color: '#666' }}>
                    <div style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      background: 'linear-gradient(45deg, #e0e0e0, #bdbdbd)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 16px',
                      fontSize: '24px'
                    }}>
                      👤
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: '500' }}>Waiting for video...</div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>

        {/* Debug Info - Material UI Expansion Panel Style */}
        <div style={{
          marginTop: '24px',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
          <details>
            <summary style={{
              padding: '20px 24px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              color: '#333',
              backgroundColor: 'rgba(0, 0, 0, 0.02)',
              borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
              listStyle: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <span>🔍 System Diagnostics</span>
              <span style={{ fontSize: '12px', color: '#666' }}>▼</span>
            </summary>
            <div style={{
              padding: '24px',
              fontSize: '14px',
              fontFamily: 'monospace',
              color: '#555',
              backgroundColor: '#fafafa'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '24px' }}>
                <div>
                  <div style={{ fontWeight: '600', color: '#2196f3', marginBottom: '8px' }}>Connection Info</div>
                  <div>Socket ID: <span style={{ color: '#4caf50' }}>{socket?.id}</span></div>
                  <div>Active Streams: <span style={{ color: '#ff9800' }}>{Object.keys(remoteStreams).length}</span></div>
                  <div>Peer Connections: <span style={{ color: '#9c27b0' }}>{Object.keys(peerConnectionsRef.current).length}</span></div>
                </div>
                <div>
                  <div style={{ fontWeight: '600', color: '#2196f3', marginBottom: '8px' }}>Room Details</div>
                  <div>Room Users: <span style={{ color: '#607d8b' }}>[{roomUsers.join(', ')}]</span></div>
                </div>
                <div>
                  <div style={{ fontWeight: '600', color: '#2196f3', marginBottom: '8px' }}>Stream Details</div>
                  {Object.entries(remoteStreams).map(([userId, stream]) => (
                    <div key={userId} style={{ marginBottom: '4px' }}>
                      <div>• {userId.slice(-4)}: {stream ? `Active (${stream.getTracks().length} tracks)` : 'No stream'}</div>
                      {stream && (
                        <div style={{ marginLeft: '16px', fontSize: '12px', color: '#666' }}>
                          - Video: {stream.getVideoTracks().length} | Audio: {stream.getAudioTracks().length}
                          - Stream ID: {stream.id}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div style={{
                marginTop: '20px',
                padding: '12px',
                background: 'linear-gradient(45deg, #ff9800, #ffb74d)',
                borderRadius: '8px',
                textAlign: 'center',
                color: 'white',
                fontWeight: '600'
              }}>
                🎥 RENDERING {Object.keys(remoteStreams).length} REMOTE VIDEOS
              </div>
            </div>
          </details>
        </div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

// Remote Video Component - Material UI Style
const RemoteVideo = ({ userId, username, stream }) => {

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    console.log(`🎬 RemoteVideo effect for ${userId}:`, {
      hasStream: !!stream,
      hasVideoRef: !!videoRef.current,
      streamId: stream?.id,
      trackCount: stream?.getTracks().length,
      currentSrc: videoRef.current?.srcObject?.id
    });
    
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.muted = false;
      setIsPlaying(false);
      
      // IMMEDIATE play attempt
      videoRef.current.play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch(e => {
          setIsPlaying(false);
        });
    }
  }, [stream, userId]);

  const handleVideoClick = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch(e => {
          console.error(`❌ MANUAL PLAY FAILED for ${userId}:`, e);
        });
    }
  };

  return (
    <div style={{
      width: '400px',
      height: '300px',
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      transition: 'all 0.3s ease'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-8px)';
      e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.15)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
    }}>
      <div style={{
        background: isPlaying ? 'linear-gradient(45deg, #4caf50, #66bb6a)' : 'linear-gradient(45deg, #f44336, #ef5350)',
        padding: '16px',
        color: 'white',
        fontWeight: '600',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '20px'
      }}>
        <span>{username} {isPlaying ? '🟢 LIVE' : '⏸️ Click to Play'}</span>
        <div style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: isPlaying ? '#4caf50' : '#f44336',
          animation: 'pulse 2s infinite'
        }}></div>
      </div>
      <div style={{ width: '400px', height: '250px', position: 'relative' }}>
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted={false}
          style={{
            width: '400px',
            height: '250px',
            objectFit: 'cover',
            backgroundColor: '#000',
            cursor: 'pointer'
          }}
          onClick={handleVideoClick}
          onCanPlay={() => {
            if (videoRef.current && !isPlaying) {
              videoRef.current.play().then(() => setIsPlaying(true)).catch(() => {});
            }
          }}
          onLoadedMetadata={() => {
            if (videoRef.current && !isPlaying) {
              videoRef.current.play().then(() => setIsPlaying(true)).catch(() => {});
            }
          }}
          onPlaying={() => {

            setIsPlaying(true);
          }}
          onError={(e) => console.error(`❌ Video error for ${userId}:`, e)}
        />
        {!isPlaying && stream && (
          <div style={{
            position: 'absolute',
            inset: 0,
            width: '400px',
            height: '250px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            backdropFilter: 'blur(4px)'
          }}>
            <button 
              onClick={handleVideoClick}
              style={{
                padding: '16px 32px',
                fontSize: '16px',
                fontWeight: '600',
                background: 'linear-gradient(45deg, #f44336, #ef5350)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                boxShadow: '0 4px 20px rgba(244, 67, 54, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.boxShadow = '0 8px 30px rgba(244, 67, 54, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 4px 20px rgba(244, 67, 54, 0.3)';
              }}
            >
              <svg style={{ width: '24px', height: '24px' }} fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z"/>
              </svg>
              <span>Play Video</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoChat;